import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { LocationsTab } from './tabs/LocationsTab';
import { SpansTab } from './tabs/SpansTab';
import { SectionsTab } from './tabs/SectionsTab';
import { TowerWeightsTab } from './tabs/TowerWeightsTab';
import { TabNavigation } from './tabs/TabNavigation';
// import  {FoundationQuantityTab} from './tabs/FoundationQuantityTab';
// import { TabNavigation } from './tabs/TabNavigation';

interface ProjectTablesProps {
    selectedNode?: any;
    projectData?: any;
}

type TabKey =
    | 'locations'
    | 'spans'
    | 'sections'
    | 'foundationQty'
    | 'foundationSoil'
    | 'foundationTower'
    | 'towerWeights';

interface TabDefinition {
    key: TabKey;
    label: string;
}

const TABS: TabDefinition[] = [
    { key: 'towerWeights', label: 'Tower Weights' },
    { key: 'locations', label: 'Locations' },
    { key: 'spans', label: 'Spans' },
    { key: 'sections', label: 'Sections' },
    { key: 'foundationQty', label: 'Foundation Qty' },
    { key: 'foundationSoil', label: 'Foundation by Soil' },
    { key: 'foundationTower', label: 'Foundation by Tower' }

];

export const ProjectTables: React.FC<ProjectTablesProps> = ({ selectedNode, projectData }) => {
    const [activeTab, setActiveTab] = useState<TabKey>(TABS[0].key);
    const theme = useTheme();

    const renderActiveTab = () => {
        const commonProps = {
            selectedNode,
            projectData,
        };

        switch (activeTab) {
            case 'locations':
                return <LocationsTab {...commonProps} />;
            case 'spans':
                return <SpansTab {...commonProps} />;
            case 'sections':
                return <SectionsTab {...commonProps} />;
            case 'foundationQty':
                return <FoundationQuantityTab {...commonProps} />;
            case 'foundationSoil':
                return <FoundationSoilTab {...commonProps} />;
            case 'foundationTower':
                return <FoundationTowerTab {...commonProps} />;
            case 'towerWeights':
                // Rendering tower weights tab
                return <TowerWeightsTab {...commonProps} />;
            //return <TowerWeightsPage {...commonProps} />;
            default:
                return null;
        }
    };

    return (
        <View style={styles.container}>
            <TabNavigation
                tabs={TABS}
                activeTab={activeTab}
                onTabChange={(key) => setActiveTab(key as TabKey)}
            >
                <View style={styles.tabContent}>
                    {renderActiveTab()}
                </View>
            </TabNavigation>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0, // Important for flex child
    },
    tabContent: {
        flex: 1,
        overflow: 'auto',
        minHeight: 0, // Important for flex child
    },
});
